import {
    Group,
    Stack,
    Title,
} from '@mantine/core'
import { DealParams } from 'app/models/deal-params'
import StatusPill from '../../common/pill-status'
import DealHoldIndicator from 'app/views/components/deal-hold-indicator'


interface props {
    deal: DealParams
    showStatusPill?: boolean
    customTitle?: string
}

export default function DealHeader({ deal, customTitle, showStatusPill = true }: props) {
    return (
        <Stack className="detailsHeader">
            <Group noWrap>
                {customTitle ?
                    <Title className='detailsTitle'>{customTitle}</Title> :
                    <Title className='detailsTitle'>{deal ? deal.dealName : ''}</Title>}
                {showStatusPill && (
                    <>
                        <StatusPill
                            updated={true}
                            state={deal?.status ?? 'Draft'}
                            additionalState={deal?.amendmentType ?? ''}
                        />
                        <DealHoldIndicator deal={deal} />
                    </>
                )}
            </Group>
        </Stack>
    )
}